angular.module('GlobalHelpersModule').filter "allergyActiveString", ->
  (allergy) ->
    allergy = allergy or ""

    if allergy.isActive
      'Active'
    else
      'Inactive'